import { ColoringCondition } from '../../wtFramework';
import { SelectorType, IBindable, IFrequency, RawInformation } from '../../models';

export interface ISeriesConfiguration extends IBindable {
    color: string;
    coloringConditions?: ColoringCondition[];
    customLegend?: string;
    decimals?: number;
    guid: string;
    hasOwnAxis?: boolean;
    isBarsVisible: boolean;
    isBoundToGroup: boolean;
    isLineVisible: boolean;
    isStacked?: boolean;
    isSymbolVisible: boolean;
    max?: number;
    min?: number;
    offset?: IFrequency;
    pane?: number;
    rawInformation?: RawInformation;
    relativePath: string;
    renderingMode?: string;
    serieState: number;
    seriesType?: string; //line, area,...; make an enum
    sortOrder?: number;
    symbol: string;
    type?: SelectorType;
    value: string;
    valueType: string;
    y0?: (d) => number; //for area series
    y1?: (d) => number; //for area series
    yMax?: number;
    yMin?: number;
}

export class SeriesConfiguration implements ISeriesConfiguration {
    guid: string;
    color: string;
    coloringConditions: ColoringCondition[];
    valueType: string;
    isSymbolVisible: boolean;
    isLineVisible: boolean;
    isBarsVisible: boolean;
    isBoundToGroup: boolean;
    isValueLabelsVisible: boolean;
    isStacked?: boolean;
    isClipped: boolean;
    symbol: string;
    type: SelectorType;
    value: string;
    hasOwnAxis: boolean;
    seriesType: string; //line, area,...; make an enum
    y0: (d) => number; //for area series
    y1: (d) => number; //for area series
    relativePath: string;
    sortOrder: number;
    yMin: number;
    yMax: number;
    pane: number;
    renderingMode: string;
    serieState: number;
    decimals?: number;
    customLegend?: string;
    offset?: IFrequency;
    originalGuid: string;
    min: number;
    max: number;
    hasReconciledValue: boolean;
    isConstraint: boolean;
    isQuery?: boolean;
    isXAxis?: boolean;
    isBoundIncludehildren: boolean;
    name?: string;
    hasAlarm?: boolean;

    rawInformation?: RawInformation;

    constructor(guid: string, color: string, symbol: string) {
        this.guid = guid;
        this.color = color;
        this.symbol = symbol;
        this.isSymbolVisible = false;
        this.isLineVisible = true;
        this.isBarsVisible = false;
        this.isStacked = false;
        this.coloringConditions = [];
        this.value = 'average';
        this.hasOwnAxis = false;
        this.serieState = 0;
        this.offset = {
            interval: null,
            intervalTimeUnit: null
        };
    }
}